import { c as _c } from "react/compiler-runtime";
import React, { type ReactNode } from "react";
import { motion } from "motion/react";
const FadeIn = t0 => {
  const $ = _c(12);
  let children;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      className: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
  }
  const className = t1 === undefined ? "" : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0
    };
    t3 = {
      opacity: 1
    };
    t4 = {
      opacity: 0
    };
    t5 = {
      duration: 0.15
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== children || $[9] !== className || $[10] !== props) {
    t6 = <motion.div initial={t2} animate={t3} exit={t4} transition={t5} className={className} {...props}>{children}</motion.div>;
    $[8] = children;
    $[9] = className;
    $[10] = props;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default FadeIn;